import { Pipe, PipeTransform } from '@angular/core'

import { LocalDate, NumberMonth, Timestamp, TuettuKieli } from '@lemon/core/model/common'
import { DateService } from '@lemon/core/service/date.service'

import { LemonTranslationService } from '../service/lemon-translation.service'

import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Pipe({
  name: 'ldate',
  standalone: false,
})
export class LemonDatePipe implements PipeTransform {
  constructor(
    private dateService: DateService,
    private lemonTranslationService: LemonTranslationService,
  ) {}

  transform(value: Date): Observable<string> {
    return this.lemonTranslationService.currentLanguageObservable.pipe(
      map(kieli => {
        if (!value || !kieli) {
          return ''
        }
        return this.dateService.muotoilePaivaDate(value, kieli)
      }),
    )
  }
}

@Pipe({
  name: 'ldatetime',
  standalone: false,
})
export class LemonDateAndTimePipe implements PipeTransform {
  constructor(
    private dateService: DateService,
    private lemonTranslationService: LemonTranslationService,
  ) {}

  transform(value: Date): Observable<string> {
    return this.lemonTranslationService.currentLanguageObservable.pipe(
      map(kieli => {
        if (!value || !kieli) {
          return ''
        }
        return this.dateService.muotoilePaivaJaAikaDate(value, kieli)
      }),
    )
  }
}

@Pipe({
  name: 'ldatel',
  standalone: false,
})
export class LemonDateWithLocalePipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  transform(value: Date, kieli: TuettuKieli): string {
    if (!value || !kieli) {
      return ''
    }
    return this.dateService.muotoilePaivaDate(value, kieli)
  }
}

@Pipe({
  name: 'lnumberpvm',
  standalone: false,
})
export class LemonNumberDatePipe implements PipeTransform {
  constructor(
    private dateService: DateService,
    private lemonTranslationService: LemonTranslationService,
  ) {}

  transform(value: number): Observable<string> {
    return this.lemonTranslationService.currentLanguageObservable.pipe(
      map(kieli => {
        if (!value || !kieli) {
          return ''
        }
        return this.dateService.muotoileNumberPaiva(value, kieli)
      }),
    )
  }
}

@Pipe({
  name: 'lnumberpvmjaaika',
  standalone: false,
})
export class LemonNumberDateAndTimePipe implements PipeTransform {
  constructor(
    private dateService: DateService,
    private lemonTranslationService: LemonTranslationService,
  ) {}

  transform(value: number): Observable<string> {
    return this.lemonTranslationService.currentLanguageObservable.pipe(
      map(kieli => {
        if (!value || !kieli) {
          return ''
        }
        return this.dateService.muotoilePaivaJaAikaDate(this.dateService.numberTimestampToDate(value), kieli)
      }),
    )
  }
}

@Pipe({
  name: 'lnumberpvml',
  standalone: false,
})
export class LemonNumberDateWithLocalePipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  transform(value: number, kieli: TuettuKieli): string {
    if (!value || !kieli) {
      return ''
    }
    return this.dateService.muotoileNumberPaiva(value, kieli)
  }
}

@Pipe({
  name: 'lnumberpvmlnarrow',
  standalone: false,
})
export class LemonNumberDateWithLocaleNarrowPipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  transform(value: number, kieli: TuettuKieli): string {
    if (!value || !kieli) {
      return ''
    }
    return this.dateService.muotoileNumberPaivaKapea(value, kieli)
  }
}

@Pipe({
  name: 'lokaalipvm',
  standalone: false,
})
export class LemonLocalDatePipe implements PipeTransform {
  constructor(
    private dateService: DateService,
    private lemonTranslationService: LemonTranslationService,
  ) {}

  transform(value: LocalDate): Observable<string> {
    return this.lemonTranslationService.currentLanguageObservable.pipe(
      map(kieli => {
        if (!value || !kieli) {
          return ''
        }
        return this.dateService.muotoilePaikallinenPaiva(value, kieli)
      }),
    )
  }
}

@Pipe({
  name: 'lokaalipvml',
  standalone: false,
})
export class LemonLocalDateWithLocalePipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  transform(value: LocalDate, kieli: TuettuKieli): string {
    if (!value || !kieli) {
      return ''
    }
    return this.dateService.muotoilePaikallinenPaiva(value, kieli)
  }
}

@Pipe({
  name: 'ltimestamp',
  standalone: false,
})
export class LemonTimestampPipe implements PipeTransform {
  constructor(
    private dateService: DateService,
    private lemonTranslationService: LemonTranslationService,
  ) {}

  transform(value: Timestamp): Observable<string> {
    return this.lemonTranslationService.currentLanguageObservable.pipe(
      map(kieli => {
        if (!value || !kieli) {
          return ''
        }
        return this.dateService.muotoilePaiva(value, kieli)
      }),
    )
  }
}

@Pipe({
  name: 'ltimestampl',
  standalone: false,
})
export class LemonTimestampWithLocalePipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  transform(value: Timestamp, kieli: TuettuKieli): string {
    if (!value || !kieli) {
      return ''
    }
    return this.dateService.muotoilePaiva(value, kieli)
  }
}

@Pipe({
  name: 'ltimestamptime',
  standalone: false,
})
export class LemonTimestampDateAndTimePipe implements PipeTransform {
  constructor(
    private dateService: DateService,
    private lemonTranslationService: LemonTranslationService,
  ) {}

  transform(value: Timestamp): Observable<string> {
    return this.lemonTranslationService.currentLanguageObservable.pipe(
      map(kieli => {
        if (!value || !kieli) {
          return ''
        }
        const asDate = this.dateService.timestampToDate(value)
        return this.dateService.muotoilePaivaJaAikaDate(asDate, kieli)
      }),
    )
  }
}

@Pipe({
  name: 'ltimestamptimel',
  standalone: false,
})
export class LemonTimestampDateAndTimeWithLocalePipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  transform(value: Timestamp, kieli: TuettuKieli): string {
    if (!value || !kieli) {
      return ''
    }
    const asDate = this.dateService.timestampToDate(value)
    return this.dateService.muotoilePaivaJaAikaDate(asDate, kieli)
  }
}
@Pipe({
  name: 'lokaalimonthyear',
  standalone: false,
})
export class LemonLocalToMonthAndYearPipe implements PipeTransform {
  constructor(
    private dateService: DateService,
    private lemonTranslationService: LemonTranslationService,
  ) {}

  transform(value: LocalDate): Observable<string> {
    return this.lemonTranslationService.currentLanguageObservable.pipe(
      map(kieli => {
        if (!value || !kieli) {
          return ''
        }
        return this.dateService.muotoileKuukausiJaVuosiPaikallinen(value, kieli)
      }),
    )
  }
}

@Pipe({
  name: 'numbermonthtomonthyear',
  standalone: false,
})
export class LemonNumberMonthToMonthAndYearPipe implements PipeTransform {
  constructor(
    private dateService: DateService,
    private lemonTranslationService: LemonTranslationService,
  ) {}

  transform(value: NumberMonth): Observable<string> {
    return this.lemonTranslationService.currentLanguageObservable.pipe(
      map(kieli => {
        if (!value || !kieli) {
          return ''
        }
        const localMonth = this.dateService.numberToLocalMonth(value)
        return this.dateService.muotoileKuukausiJaVuosiPaikallinen({ year: localMonth.year, month: localMonth.month }, kieli)
      }),
    )
  }
}
